import React from "react";
import { Link } from 'react-router-dom'
function Portfolio() {
        return(
         <div className="projects">
            <br/><br/><br/><br/><br/>
            <h1>QUICKSERVE PROJECT</h1>
            <img src="assets/imgs/quickserve.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>ABOUT</h1>
            <img src="assets/imgs/quickserveabout.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>PERSONAL WEBSITE</h1>
            <img src="assets/imgs/chetanwix.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>ADMIN PROJECT</h1>
            <img src="assets/imgs/admin.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>RESTAURANT PROJECT</h1>
            <img src="assets/imgs/burger.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>FASHION</h1>
            <img src="assets/imgs/girl.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
            <h1>E SHOP PROJECT</h1>
            <img src="assets/imgs/shop.png"  alt="Cinque Terre" width="100%" height="900px"></img>
            <br/><br/><br/><br/><br/>
            <hr/><hr/>
         </div>
        )
}
export default Portfolio